import React, { useState } from 'react';
import CtaList from '../../Global/Cta/CtaList';

import './index.scss';

function Accordion({ items, renderCustomTitle = null, defaultActive = 0 }) {
  const [activeItem, setActiveItem] = useState(defaultActive);

  const handleOnChangeAccordion = (newIndex) => {
    if (activeItem === newIndex) {
      setActiveItem(-1);
    } else {
      setActiveItem(newIndex);
    }
  };

  if (items.length === 0) return null;

  return (
    <div className="accordion">
      {items.map((item, index) => (
        <div
          key={index}
          className={`item ${activeItem === index ? 'active' : ''}`}
          onClick={() => handleOnChangeAccordion(index)}
        >
          <div className="ac-title">
            <h3>{renderCustomTitle ? renderCustomTitle(item) : item?.title}</h3>
            {activeItem === index ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M28.5142 30.1179L35.0439 36.6476C35.2616 36.8579 35.5531 36.9742 35.8558 36.9716C36.1584 36.969 36.4479 36.8476 36.6619 36.6336C36.8759 36.4195 36.9973 36.13 37 35.8274C37.0026 35.5248 36.8862 35.2332 36.676 35.0155L30.1463 28.4858L36.676 21.9561C36.8862 21.7384 37.0026 21.4469 37 21.1442C36.9973 20.8416 36.8759 20.5521 36.6619 20.3381C36.4479 20.1241 36.1584 20.0027 35.8558 20C35.5531 19.9974 35.2616 20.1138 35.0439 20.324L28.5142 26.8537L21.9845 20.324C21.7658 20.119 21.476 20.007 21.1762 20.0119C20.8765 20.0168 20.5904 20.138 20.3785 20.3501C20.1666 20.5621 20.0455 20.8483 20.0408 21.1481C20.0362 21.4478 20.1483 21.7376 20.3535 21.9561L26.8821 28.4858L20.3524 35.0155C20.2421 35.122 20.1542 35.2493 20.0937 35.3902C20.0332 35.531 20.0014 35.6824 20 35.8357C19.9987 35.989 20.0279 36.141 20.086 36.2828C20.144 36.4247 20.2297 36.5535 20.3381 36.6619C20.4465 36.7703 20.5753 36.856 20.7172 36.914C20.859 36.9721 21.011 37.0013 21.1643 37C21.3176 36.9986 21.469 36.9668 21.6098 36.9063C21.7507 36.8458 21.878 36.7579 21.9845 36.6476L28.5142 30.1179Z"
                  fill="#011C25"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M28 54C42.3594 54 54 42.3594 54 28C54 13.6406 42.3594 2 28 2C13.6406 2 2 13.6406 2 28C2 42.3594 13.6406 54 28 54ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
                  fill="#011C25"
                />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.134 26.1388V16.9045C29.1288 16.6018 29.0049 16.3134 28.789 16.1013C28.5731 15.8891 28.2826 15.7702 27.9799 15.7702C27.6773 15.7702 27.3867 15.8891 27.1709 16.1013C26.955 16.3134 26.8311 16.6018 26.8259 16.9045V26.1388L17.5915 26.1388C17.2889 26.1441 17.0005 26.268 16.7883 26.4838C16.5762 26.6997 16.4573 26.9902 16.4573 27.2929C16.4573 27.5955 16.5762 27.8861 16.7883 28.102C17.0005 28.3178 17.2889 28.4417 17.5915 28.447H26.8259V37.6813C26.8355 37.981 26.9613 38.2651 27.1767 38.4736C27.3921 38.6821 27.6801 38.7986 27.9799 38.7985C28.2797 38.7984 28.5677 38.6817 28.7829 38.473C28.9982 38.2644 29.1238 37.9802 29.1332 37.6805L29.134 28.447L38.3684 28.447C38.5216 28.4496 38.6739 28.4218 38.8162 28.365C38.9586 28.3082 39.0882 28.2236 39.1975 28.1161C39.3068 28.0087 39.3936 27.8806 39.4529 27.7392C39.5122 27.5979 39.5427 27.4462 39.5427 27.2929C39.5427 27.1396 39.5122 26.9879 39.4529 26.8465C39.3936 26.7052 39.3068 26.5771 39.1975 26.4696C39.0882 26.3622 38.9586 26.2776 38.8162 26.2208C38.6739 26.164 38.5216 26.1361 38.3684 26.1388H29.134Z"
                  fill="#011C25"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M46.3848 9.61522C36.2311 -0.538406 19.7689 -0.538406 9.61522 9.61522C-0.538407 19.7689 -0.538406 36.2311 9.61522 46.3848C19.7689 56.5384 36.2311 56.5384 46.3848 46.3848C56.5384 36.2311 56.5384 19.7689 46.3848 9.61522ZM47.799 8.20101C36.8643 -2.73367 19.1357 -2.73367 8.20101 8.20101C-2.73367 19.1357 -2.73367 36.8643 8.20101 47.799C19.1357 58.7337 36.8643 58.7337 47.799 47.799C58.7337 36.8643 58.7337 19.1357 47.799 8.20101Z"
                  fill="#011C25"
                />
              </svg>
            )}
          </div>

          <div id="ac-content" className="ac-content">
            <div className="ac-content" dangerouslySetInnerHTML={{ __html: item.text }} />
            {item.ctas && (
              <div className="cta-accordion">
                <CtaList ctas={item.ctas} />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Accordion;
